"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classNames = require("classnames");
var rql_pills_1 = require("./rql_pills");
var search_filters_1 = require("./search_filters");
var search_controls_1 = require("./search_controls");
var RQLSearchOverview = /** @class */ (function (_super) {
    tslib_1.__extends(RQLSearchOverview, _super);
    function RQLSearchOverview() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RQLSearchOverview.prototype.render = function () {
        var sort = this.props.filters.find(function (filter) { return filter.widgetType === search_filters_1.WidgetType.SORT; });
        var classes = classNames('search-overview', { 'search-overview--loading': this.props.loading });
        return (React.createElement("nav", { className: classes },
            React.createElement("section", { className: "search-overview__primary" },
                React.createElement("div", { className: "search-overview__count" },
                    React.createElement("h2", null, this.props.totalText),
                    this.props.tipText &&
                        React.createElement("p", { className: "mb-0 size-70" }, this.props.tipText)),
                React.createElement("div", { className: "search-overview__feed" }, this.props.followButton)),
            React.createElement("div", { className: "search-overview__secondary" },
                React.createElement("div", { className: "search-overview__filters" },
                    React.createElement(rql_pills_1.default, { filters: this.props.filters })),
                React.createElement("div", { className: "search-overview__controls" },
                    React.createElement(search_controls_1.default, { sort: sort })))));
    };
    return RQLSearchOverview;
}(React.Component));
exports.default = RQLSearchOverview;
//# sourceMappingURL=rql_search_overview.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/rql_search_overview.js
// module id = xqlv
// module chunks = 0 1 2 3 9 10 14 20